<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-11-28 22:33:47
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTab">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="平台名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入平台名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="平台简称" prop="referred">
            <el-input
              v-model="ruleForm.referred"
              placeholder="请输入平台简称"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司地址" prop="address">
            <el-input
              v-model="ruleForm.address"
              placeholder="请输入公司地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="tel">
            <el-input
              v-model="ruleForm.tel"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="Logo" prop="logo">
            <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :headers="deader"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
            >
              <img v-if="ruleForm.logo" :src="ruleForm.logo" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="" prop="logo">
            <div style="margin-right: auto">
              Logo图片可用于处方打印、叫号屏显示，建议白色或透明背景，推荐尺寸720*180
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              class="btn"
              style="margin-right: auto"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
import axiosUrl from "../../api/axios.js";
export default {
  components: {
    system,
  },
  data() {
    return {
      input: "",
      leftList: this.Plugins.systemData(),
      ruleForm: {
        name: "",
        referred: "",
        address: "",
        tel: "",
        logo: "",
      },
      rules: { name: [{ required: true, message: "必填项", trigger: "blur" }] },
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      deader: {
        "x-ba-admin-token": localStorage.getItem("TOKEN"),
      },
      uploadUrl: "",
    };
  },
  mounted() {
    this.uploadUrl = axiosUrl.defaults.baseURL + "admapi/sys/file/upload";
    this.getDetail();
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.ruleForm.logo = res.data;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            platformName: this.ruleForm.name,
            companyAdress: this.ruleForm.address,
            companyPhone: this.ruleForm.tel,
            logo: this.ruleForm.logo,
            internalAbbreviation: this.ruleForm.referred,
          };
          this.$axios
            .post(`/admapi/sys/configure/update`, param)
            .then(({ data }) => {
              this.$message({
                message: "修改成功",
                type: "success",
              });
            })
            .catch()
            .finally();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getDetail() {
      this.$axios
        .post(`/admapi/sys/configure/get`)
        .then(({ data }) => {
          this.ruleForm.name = data.platformName;
          this.ruleForm.address = data.companyAdress;
          this.ruleForm.tel = data.companyPhone;
          this.ruleForm.logo = data.logo;
          this.ruleForm.referred = data.internalAbbreviation;
        })
        .catch()
        .finally();
    },
    handleRemove(file) {
      console.log(file);
    },
    handleDownload(file) {
      console.log(file);
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
</style>
